import React, { useState } from 'react'
import {
  Button,
  Input,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Row,
  Col,
  Checkbox,
  Select
} from 'antd'
import IntlMessages from '../util/IntlMessages'
import ds from '../Services/DataServices'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch } from 'react-redux'
import { loadData } from '../appRedux/actions/Setting'
import { IntlProvider } from 'react-intl'
import { BEHAVIOUR_TYPE } from '../Services/DataServices'
import { notAllowMsgCheck, isEmptyObject } from '../appRedux/actions'
import { loadSellAttributeData } from '../appRedux/actions/Sell'
import { TableName } from '../constants/TableName'
import { SellAttribGroupIcons } from '../constants/StoreSetting'
import ShowIconSellGroup from '../routes/Sell/Settings/ShowIconSellGroup'
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const AddSellAttributesGroup = props => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [visible, setVisible] = React.useState(false)
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const [getIsShow, setIsShow] = React.useState(false)
  const [getIsActive, setIsActive] = React.useState(false)
  const [getIsLoading, setIsLoading] = React.useState(false)
  const [getSellAttributeData, setSellAttributeData] = React.useState([])
  const methodType = props.behavior
  const dataLength = props.length ? props.length : 0
  const handleOk = () => {
    setConfirmLoading(true)
    setTimeout(() => {
      setVisible(false)
      setConfirmLoading(false)
    }, 2000)
  }
  const handleCancel = () => {
    setVisible(false)
  }
  const onFinishFailed = errorInfo => {
    message.error('Failed to add type, Please enter proper data')
  }

  const isloadAttributeData = useSelector(
    ({ Sell }) => Sell.isloadAttributeData
  )

  React.useEffect(() => {
    const attrData = props.data ? props.data : []
    form.setFieldsValue({
      Title: attrData.title,
      DisplaySeqNo: attrData.displaySeqNo,
      Icon: attrData.icon ? attrData.icon : ''
    })
    setIsActive(attrData.isActive)
    setSellAttributeData(attrData)
  }, [props.data])

  const onFinish = async values => {
    setVisible(false)
    setIsShow(true)
    let body = {
      BehaviorName: methodType ? parseInt(methodType) : 1,
      SellAttributeGroupID:
        getSellAttributeData && getSellAttributeData.sellAttributeGroupID
          ? getSellAttributeData.sellAttributeGroupID
          : '',
      Title: values.Title,
      DisplaySeqNo: parseInt(values.DisplaySeqNo ? values.DisplaySeqNo : 0),
      IsActive: getIsActive,
      Icon: values.Icon ? values.Icon : ''
    }
    const behavior =
      methodType && methodType == '3' ? BEHAVIOUR_TYPE.PUT : BEHAVIOUR_TYPE.POST
    postSellAttributeGroup(body, behavior)
    form.resetFields()
    setTimeout(() => {
      setIsShow(false)
    }, 2000)
  }
  async function postSellAttributeGroup (body, behavior) {
    const resp = ds.addUpdateDeleteSellAttributeGroup(body, behavior)
    await resp
      .then(res => {
        setIsLoading(false)
        if (res) {
          if (res.data) {
            let message = res.data.data
            dispatch(loadSellAttributeData(message))
            message.success(message)
          }
        } else {
          message.error(res.data.data)
        }
      })
      .catch(e => {
        setIsLoading(false)
        notAllowMsgCheck(e)
      })
  }
  const showModal = () => {
    if (dataLength < 4) {
      setVisible(true)
    } else {
      message.info('Only 6 attributes are allowed')
    }
  }
  const valideDuplicateName = (rule, value, callback) => {
    let body = {
      TableName: TableName.SellAttributeGroups,
      SearchValue: value,
      ID:
        getSellAttributeData && getSellAttributeData.sellAttributeGroupID
          ? getSellAttributeData.sellAttributeGroupID
          : `0&&_bd98-6131-47dd-8ac8-4bd1856d2a60`
    }
    const getIsExist = ds.checkIsNameExist(body, BEHAVIOUR_TYPE.POST)
    getIsExist
      .then(response => {
        if (response) {
          //setIsOrderNumberExist(response);
          callback('This Sell Attribute name exists. Add a different one.')
        } else {
          callback()
        }
      })
      .catch(e => {})
  }

  return (
    <div>
      {getIsShow ? (
        <div style={{ marginRight: '660px' }}>
          <Spin
            tip={<IntlMessages id='sell.settings.addgroup' />}
            spinning={getIsShow}
            size='large'
          ></Spin>
        </div>
      ) : (
        <div>
          {methodType && methodType == '3' ? (
            <span>
              <a onClick={showModal} className='pen-edit'>
                <i className='icon icon-edit' />
              </a>
            </span>
          ) : (
            <Button
              className='dk-btn-add'
              type='primary'
              onClick={showModal}
              size='large'
            >
              <IntlMessages id='sell.settings.addgroup' />
            </Button>
          )}

          <Modal
            className='NewSellAttributeGroup-modal'
            title={
              <IntlMessages
                id={`${
                  methodType && methodType == '3'
                    ? 'sell.settings.editsellattributegroup'
                    : 'sell.settings.newsellattributegroup'
                }`}
              />
            }
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            centered={true}
            width={'400px'}
            footer={
              <>
                <Button
                  form='SellAttributeGroup'
                  className='dk-btn-add'
                  type='primary'
                  htmlType='submit'
                >
                  <IntlMessages id='sell.settings.addgroup' />
                </Button>
              </>
            }
          >
            <Form
              {...formItemLayout}
              form={form}
              name='SellAttributeGroup'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
              className='col-pad-label'
            >
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                name='Title'
                label={
                  <span>
                    <IntlMessages id='sell.settings.grouptitle' />
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please enter group name',
                    whitespace: true
                  },
                  {
                    validator: valideDuplicateName
                  }
                ]}
              >
                <Input placeholder='Group Name' />
              </Form.Item>

              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                name='DisplaySeqNo'
                label={
                  <span>
                    <IntlMessages id='sell.settings.groupdisplayseqno' />
                  </span>
                }
              >
                <Input placeholder='Enter display seq no' />
              </Form.Item>

              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                name='Icon'
                label={
                  <span>
                    <IntlMessages id='sell.settings.icon' />
                  </span>
                }
              >
                <Select size='large' optionFilterProp='children'>
                  <Select.Option key={2342342} value={''}>
                    {'NONE'}
                  </Select.Option>
                  {SellAttribGroupIcons.map((data, index) => {
                    return (
                      <Select.Option key={index} value={data.label}>
                        {data.label}
                        <span style={{ marginLeft: 24 }}>
                          <ShowIconSellGroup type={data.label} />
                        </span>
                      </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>

              <Form.Item>
                <Checkbox
                  checked={getIsActive}
                  onChange={() => setIsActive(!getIsActive)}
                >
                  <p className='mb-0'>
                    <IntlMessages id='sell.settings.groupisactive' />{' '}
                  </p>
                </Checkbox>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default AddSellAttributesGroup
